exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".showAll{text-align:end;color:#7c75cd;cursor:pointer}.showAll:hover{-webkit-text-decoration-line:underline;text-decoration-line:underline}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-cc261cae","scoped":false,"hasInlineConfig":true}!./node_modules/stylus-loader!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/pages/profile/views/purchases/components/PurchasesHidePurchaseRequestController.vue
// module id = 8e18bbca5b1978837c5e
// module chunks = 2